import script from "./access-picker.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20AutocompleteOption"
export * from "./access-picker.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20AutocompleteOption"

const __exports__ = script;

export default __exports__